import { render, staticRenderFns } from "./IconAdvisor.vue?vue&type=template&id=0c99cd1a"
import script from "./IconAdvisor.vue?vue&type=script&lang=js"
export * from "./IconAdvisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports